import BaseApi from '../base/base'
import CustomText from "../../models/custom_text";

export default class CustomTextApi extends BaseApi {
  constructor() {
    super()
    this.path = '/custom_texts'
  }
  async index() {
    this.path = '/custom_texts'
    const response = await this.getRequest()
    return response.data.map((element) => {
      return new CustomText(element)
    })
  }
}
